import React from 'react';
import TemplateComponent from "../../containers/template_page/template_component/template_component";

class C71Passthrough extends TemplateComponent {
    componentRender(data: any): React.ReactElement<any> {
        return (
            <div className="c71-passthrough">
                {this.props.children}
            </div>
        )
    }
}

export default C71Passthrough;